class Search {
  constructor() {
    this.autocomplete();
  }

  autocomplete() {
    if(document.querySelector('.search') != null && document.querySelector('.search') != undefined) {
      var searches = document.querySelectorAll('.search');

      searches.forEach(search => {
        var searchAutocomplete = search.querySelector('.autocomplete');

        search.querySelector('.search__input').addEventListener('input', function(e) {
          if(e.target.value.length > 2) {
            searchAutocomplete.classList.contains('autocomplete--active') ?
              null
            :
              searchAutocomplete.classList.add('autocomplete--active');
          } else {
            searchAutocomplete.classList.remove('autocomplete--active');
          }
        });
      });
    }
  }
}

$(document).ready(function() {
  const search = new Search();
});